import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-date-picker";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import TimePicker from 'react-time-picker';
import trendGraphSvg from "../../common/icons/svg/trend-graph.svg";
import trendGraphSelectedSvg from "../../common/icons/svg/trend-graph-selected.svg";
import trendTableSvg from "../../common/icons/svg/trend-table.svg";
import trendTableSelectedSvg from "../../common/icons/svg/trend-table-selected.svg";
import "./NewTrendContainer.scss";
import { connect } from "react-redux";
import { CHART_HEADER_CONST, VITAL_OPTION, parameterSorting, new_parameterOptionList, DurationOptionList, intervalOptionList, DEVICE_TYPES, new_ventilatorParameterOptionList } from "../../common/constant/common-constants";
import moment from "moment";
import { getTrendData } from "../../helper/report-helper";
import { getVentilatorTrendData } from "../../helper/report-helper";
import TrendTable from "../../components/Table/TrendTable/TrendTable";
import TrendGraph from "../../components/TrendGraph/TrendGraph";
import DevicesTab from "../PatientRightPanel/MachineTabs/DevicesTab";
import { Spinner } from "../../components/Loader/Spinner"
import arrow from "../../common/images/Vector.png";

function NewTrendContainer(props) {

    const [selectedParamList, setSelectedParamList] = useState([]);

    const [trendStartDate, setTrendStartDate] = useState(new Date());
    const [trendEndDate, setTrendEndDate] = useState(new Date());
    const [trendStartTime, setTrendStartTime] = useState(moment(new Date()).format("HH:mm"));
    const [trendEndTime, setTrendEndTime] = useState(moment(new Date()).format("HH:mm"));
    const [interval, setInterval] = useState(null);
    const [interval_custom, setInterval_custom] = useState(null);
    const [Isduration_custom, setIsduration_custom] = useState(false);

    const [duration, setduration] = useState(null);
    const [data, setData] = useState(null);
    const [trendOption, setTrendOption] = useState(VITAL_OPTION.VITAL_GRAPH);
    const [isGenerateReportVisible, setIsGenerateReportVisible] = useState(false);
    const [headerList, setHeaderList] = useState(
        [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00"]
    );
    const [bedId, setBedId] = useState(null);
    const [loader, setLoader] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const [isCustomPopupVisible, setIsCustomPopupVisible] = useState(false);
    const [is_interval_custom_set, set_is_interval_custom_set] = useState(false);

    const showCustomPopup = () => {
        setIsCustomPopupVisible(true);
    };

    const hideCustomPopup_onclick = () => {
        setIsCustomPopupVisible(false);
        setIsduration_custom(true)
        setduration(null)

    };

    const hideCustomPopup_cancel = () => {
        setIsCustomPopupVisible(false);
        set_is_interval_custom_set(false);
        setInterval_custom(interval);
    };


    // const dropdownRef = useRef(null);
    const parameterRef = useRef(null); // Ref for Parameter dropdown
    const durationRef = useRef(null); // Ref for Duration dropdown
    const intervalRef = useRef(null); // Ref for Interval dropdown
    const intervalRef_custom = useRef(null); // Ref for Interval dropdown


    const sortParametersById = (parameterList) => {
        return [...parameterList].sort((a, b) => parseInt(a.id) - parseInt(b.id));
    };





    const handleOutsideClick = (event) => {
        // console.log("Outside click detected");
        // console.log("intervalRef_custom-reference:", intervalRef_custom.current);
        // // console.log("ntervalRef_custom-reference---contains:", intervalRef_custom.current.contains(event.target));
        // console.log("duration-reference:", durationRef.current);
        // console.log("parameter-reference:", parameterRef.current);



        //   console.log("Event target:", event.target);

        if (!isCustomPopupVisible) {
            if (
                parameterRef.current &&
                !parameterRef.current.contains(event.target) &&
                durationRef.current &&
                !durationRef.current.contains(event.target) &&
                intervalRef.current &&
                !intervalRef.current.contains(event.target)
                // && 
                // // intervalRef_custom.current &&
                // //    !intervalRef_custom.current.contains(event.target)


            ) {


                //    console.log("Closing all dropdowns_normal");
                setIsOpen(null); // Close all dropdowns



            }
        }

        else {
            if (
                !intervalRef_custom.current.contains(event.target)
            ) {

                // console.log("Closing all dropdowns_normal");
                setIsOpen(null); // Close all dropdowns
            }
        }




    };


    //  console.log("Current isOpen state:", isOpen);

    useEffect(() => {
        if (isOpen) {
            // console.log("Add event-listener")
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        // Cleanup event listener on unmount
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [isOpen]);


    const updateTrendDateTime = (durationValue) => {
        const durationMinutes = parseInt(durationValue, 10);
        const now = new Date();

        const endDate = now;
        const startDate = new Date(
            now.getTime() - durationMinutes * 60 * 1000
        );

        // Update state
        setTrendEndDate(endDate);
        setTrendEndTime(moment(endDate).format("HH:mm"));
        setTrendStartDate(startDate);
        setTrendStartTime(moment(startDate).format("HH:mm"));
    };

    const handleSelect = (dropdown, value) => {
        if (dropdown === "interval") {
            console.log("set interval ")
            setInterval(value);
            setIsOpen(null); // Close dropdown after selection
        }
        else if (dropdown === "interval_custom") {
            setInterval_custom(value);
            console.log("set interval custom")
            set_is_interval_custom_set(true);
            setIsOpen(null); // Close dropdown after selection
        }
        else if (dropdown === "duration") {
            setduration(value);
            updateTrendDateTime(value); // Update start and end times based on duration
            setIsduration_custom(false)
            setIsOpen(null); // Close dropdown after selection
        } else if (dropdown === "parameter") {
            const allOptions =
                props.activeVitalDevice === DEVICE_TYPES["NOCCARC_PM_NX5"]
                    ? new_parameterOptionList
                    : new_ventilatorParameterOptionList;

            const sortParameters = (data) => {
                data.sort((a, b) => parameterSorting.indexOf(a.id) - parameterSorting.indexOf(b.id));
                return data;
            };

            if (value.label === "All") {
                if (selectedParamList.some((param) => param.label === "All")) {
                    // Deselect all
                    setSelectedParamList([]);
                } else {
                    // Select all, including "All"
                    const allParams = sortParameters(
                        allOptions.map((option) => ({
                            name: option.name,
                            label: option.label,
                            id: option.id,
                        }))
                    );
                    setSelectedParamList(allParams);
                }
            } else {
                // Toggle individual parameter selection
                setSelectedParamList((prev) => {
                    const updatedList = prev.some((param) => param.label === value.label)
                        ? prev.filter((param) => param.label !== value.label) // Remove from list
                        : [...prev, value]; // Add to list

                    // Automatically select "All" if all individual options are selected
                    if (
                        updatedList.length === allOptions.length - 1 &&
                        !updatedList.some((param) => param.label === "All")
                    ) {
                        return sortParameters([
                            { name: "all", label: "All", id: "0" },
                            ...updatedList,
                        ]);
                    }

                    // Automatically deselect "All" if an option is deselected
                    if (updatedList.some((param) => param.label === "All")) {
                        return updatedList.filter((param) => param.label !== "All");
                    }

                    return sortParameters(updatedList);
                });
            }
        }
    };


    const toggleDropdown = (dropdown) => {
        setIsOpen((prev) => (prev === dropdown ? null : dropdown));
    };

    const initialState = () => {
        const allOptions =
            props.activeVitalDevice === DEVICE_TYPES["NOCCARC_PM_NX5"]
                ? new_parameterOptionList
                : new_ventilatorParameterOptionList;

        // Set selected parameters in the desired format
        setSelectedParamList(
            allOptions.map((option) => ({
                name: option.name,
                label: option.label,
                id: option.id,
            }))
        );

        updateTrendDateTime(DurationOptionList[0]?.name); // Set default duration to 4 hours
        setInterval("5"); // Set default interval to 5 minutes
        setduration("1");
        setBedId(props.bedId);
    };

    // console.log("interval", interval);
    useEffect(() => {
        initialState();
    }, [props.config.activeDevice])

    useEffect(() => {
        if (bedId !== props.bedId) {
            initialState();
        }
        console.log("new bed Id !!!");
    }, [props.bedId])



    const handleTrendShow = (option) => {
        setTrendOption(option);
    }

    // console.log("selectedParamList---------------->", selectedParamList)
    useEffect(() => {

        // console.log("isCustomPopupVisible--------------------------------------->", isCustomPopupVisible)
        // console.log("Interval---------------->", interval)
        if (isCustomPopupVisible == false) {
            // console.log("Duration-------->", duration)
            if (interval) {
                // console.log("------------Getting Trend Data-----------------")
                onGenerateReport();
            }

        }


    }, [interval, duration, props.activeVitalDevice]);


    // console.log("Interval--------->", interval)
    // console.log("parameters--------->", selectedParamList)
    // console.log("trendStartDate--------->", trendStartDate)
    // console.log("trendEndDate--------->", trendEndDate)
    // console.log("trendStartTime--------->", trendStartTime)
    // console.log("trendEndTime--------->", trendEndTime)
    // console.log("Data--------->", data)











    const onGenerateReport = () => {
        setLoader(true);

        let finalinterval = null
        if (is_interval_custom_set) {
            finalinterval = interval_custom;
            setInterval(interval_custom);
            set_is_interval_custom_set(false);



        } else {

            finalinterval = interval;
            setInterval_custom(interval);

        }




        let data = {
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            startDate: moment(trendStartDate).format("YYYY-MM-DD"),
            startTime: trendStartTime,
            endDate: moment(trendEndDate).format("YYYY-MM-DD"),
            endTime: trendEndTime,
            // timeInterval: interval 
            timeInterval: finalinterval

        }




        const curr_time = new Date(); // Current date and time
        // console.log("Current DateTime:", curr_time);
        // console.log("End DateTime:", trendEndTime);
        // console.log("API Trend data PM Final----------------->",data);

        setIsGenerateReportVisible(false);
        if (props.activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5']) {
            getTrendData(data)
                .then((res) => {
                    setIsGenerateReportVisible(true);
                    setLoader(false);

                    const updatedData = res.data.map(item => {
                        return {

                            ...item,

                            bp: item.bpSystolic && item.bpDiastolic && item.bpMean ?
                                `${item.bpSystolic}/${item.bpDiastolic} (${item.bpMean})` : null,


                        };
                    });

                    // console.log(updatedData);
                    setData({ ...res, data: updatedData }); // Set the updated data to state






                    // setData(res);

                    let headerList = res.headerList || [];
                    console.log("headerList------------------------>", headerList)
                    setHeaderList(headerList);

                })
                .catch((err) => {
                    setIsGenerateReportVisible(true);
                    setLoader(false);
                    console.log(err);
                })
        } else {
            getVentilatorTrendData(data)
                .then((res) => {
                    setIsGenerateReportVisible(true);
                    setLoader(false);
                    console.log(res);
                    setData(res);

                    let headerList = res.headerList || [];

                    setHeaderList(headerList);

                })
                .catch((err) => {
                    setIsGenerateReportVisible(true);
                    setLoader(false);
                    console.log(err);
                })
        }
    }


    // console.log("Data-------------------------_>", data)
    // console.log("Data-------------------------_>", data?.data)


    return (
        <div className="new-trend-container">

            <div className="input-form">
                <div className="left">
                    <div className="trend-heading">Review</div>
                    <div className='device-select-btn-container'>
                        <div
                            className={`device-btn ${trendOption === VITAL_OPTION.VITAL_GRAPH ? "active-device-component" : ""}`}
                            onClick={() => handleTrendShow("VITAL_GRAPH")}                        >
                            Graphical
                        </div>
                        <div
                            className={`device-btn ${trendOption === VITAL_OPTION.VITAL_TABLE ? "active-device-component" : ""}`}
                            onClick={() => handleTrendShow("VITAL_TABLE")}
                        >
                            Tabular
                        </div>
                    </div>
                    {/* <div className="change-trend-container-1">
                        <div
                            className={`trend-change-icon ${trendOption === VITAL_OPTION.VITAL_TABLE ? 'selected' : ''}`}
                            onClick={() => handleTrendShow("VITAL_TABLE")}
                        >
                            Tabular
                        </div>
                    </div>
                    <div className="change-trend-container-2">
                        <div
                            className={`trend-change-icon ${trendOption === VITAL_OPTION.VITAL_GRAPH ? 'selected' : ''}`}
                            onClick={() => handleTrendShow("VITAL_GRAPH")}
                        >
                            Graphical
                        </div>
                    </div> */}

                </div>
                <div className="right">
                    {/* <div className="parameter">
                        <div className="parameter-input">
                            <div className="parameter-label">Parameter</div>

                            <div className="parameter-dropdown">


                                <div className="dropdown-container" ref={parameterRef}>
                                    <div className="dropdown-trigger" onClick={() => toggleDropdown("parameter")}>
                                        {selectedParamList.length === 0
                                            ? "Select Parameters" // Nothing is selected
                                            : selectedParamList.length ===
                                                (props.activeVitalDevice === DEVICE_TYPES["NOCCARC_PM_NX5"]
                                                    ? new_parameterOptionList.length
                                                    : new_ventilatorParameterOptionList.length)
                                                ? "All" // All options are selected
                                                : (() => {
                                                    const charLimit = 15; // Set the character limit here
                                                    let displayText = "";
                                                    let currentLength = 0;

                                                    for (let i = 0; i < selectedParamList.length; i++) {
                                                        const param = selectedParamList[i];
                                                        if (currentLength + param.label.length > charLimit) {
                                                            displayText += "...";
                                                            break;
                                                        }
                                                        displayText += (i === 0 ? "" : ", ") + param.label;
                                                        currentLength += param.label.length + 2; // Account for ", " separator
                                                    }

                                                    return displayText;
                                                })()}
                                        <img className="dropdown-arrow" src={arrow} alt="▼" />
                                    </div>

                                    {isOpen === "parameter" && (
                                        <div className="dropdown-menu">
                                            {(props.activeVitalDevice === DEVICE_TYPES["NOCCARC_PM_NX5"]
                                                ? new_parameterOptionList
                                                : new_ventilatorParameterOptionList
                                            ).map((option) => (
                                                <div
                                                    key={option.name}
                                                    className="dropdown-item"
                                                    onClick={() => handleSelect("parameter", option)}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="dropdown-checkbox"
                                                        checked={selectedParamList.some((param) => param.label === option.label)}
                                                        readOnly
                                                    />
                                                    {option.label}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>



                    </div> */}
                    {/* <div className="duration"> */}

                    <div className="duration-input">
                        <div className="duration-label">Duration</div>
                        <div className="dropdown-container" ref={durationRef}>

                            <div
                                className="dropdown-trigger"
                                onClick={() => toggleDropdown("duration")}
                            >
                                {Isduration_custom ? "Custom" : DurationOptionList.find((option) => option.name === duration)?.label
                                }
                                {/* {duration} */}
                                {/* <span className="dropdown-arrow">▼</span> */}
                                <img className="dropdown-arrow" src={arrow} alt="▼" />

                            </div>

                            {isOpen === "duration" && (
                                <div className="dropdown-menu">
                                    {DurationOptionList.map((option) => (
                                        <div
                                            key={option.name}
                                            className={`dropdown-item ${duration === option.name ? "selected" : ""
                                                }`}
                                            onClick={() => handleSelect("duration", option.name)}
                                        >
                                            {option.label}
                                        </div>
                                    ))}
                                    {/* Custom Button */}
                                    <div
                                        className="dropdown-custom-button"
                                        onClick={() => {
                                            showCustomPopup(); // Show popup
                                            setIsOpen(false);  // Close dropdown
                                        }}
                                    >
                                        Custom
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>



                    {/* </div> */}
                    {/* <div className="interval"> */}
                    <div className="interval-input">
                        <div className="interval-label">Interval</div>

                        <div className="dropdown-container" ref={intervalRef}>

                            <div
                                className="dropdown-trigger"
                                onClick={() => toggleDropdown("interval")}
                            >
                                {intervalOptionList.find((option) => option.name === interval)?.label}
                                {/* <span className="dropdown-arrow">▼</span> */}
                                <img className="dropdown-arrow" src={arrow} alt="▼" />

                            </div>

                            {isOpen === "interval" && (
                                <div className="dropdown-menu">
                                    {intervalOptionList.map((option) => (
                                        <div
                                            key={option.name}
                                            className={`dropdown-item ${interval === option.name ? "selected" : ""
                                                }`}
                                            onClick={() => handleSelect("interval", option.name)}
                                        >
                                            {option.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>








                    </div>
                    {/* </div> */}

                </div>
            </div>

            <div className="trend-data">
                {loader ? (
                    <div className="spinner-container">

                        <div className="spinner"></div>
                    </div>

                ) : (
                    <>

                        {(trendOption === VITAL_OPTION.VITAL_TABLE) && data?.data.length > 0 && (
                            <div className="trend-table-container">
                                {selectedParamList.length > 0 && (
                                    <TrendTable
                                        headerList={headerList}
                                        parameterList={sortParametersById(
                                            selectedParamList.filter((param) => param.label !== 'All')
                                        )}
                                        data={data}
                                    />
                                )}
                            </div>
                        )}
                        {(trendOption === VITAL_OPTION.VITAL_GRAPH) && data?.data.length > 0 && (
                            <TrendGraph
                                selectedParamList={sortParametersById(
                                    selectedParamList.filter((param) => param.label !== 'All')
                                )}
                                data={data}
                            />
                        )}
                    </>
                )}
            </div>



            {isCustomPopupVisible && (
                <div className="fullscreen-overlay">
                    <div className="overlay-content">
                        <div className="top">
                            <div className="top-heading">Custom Trends</div>




                        </div>
                        <div className="middle">
                            <div className="layer1">



                                <div className="start-date">
                                    <label className="date-label">Start Date</label>
                                    <div className="date-box">
                                        <DatePicker
                                            // className="trend-date"
                                            onChange={(date) => setTrendStartDate(date)}
                                            value={trendStartDate}
                                            clearIcon={false}
                                        />
                                    </div>
                                </div>



                                <div className="start-time">
                                    <label className="time-label">Start Time</label>



                                    <div className="time-box">
                                        <TimePicker
                                            // className="trend-time"
                                            onChange={(date) => setTrendStartTime(date)}
                                            value={trendStartTime}
                                            clearIcon={false}
                                            disableClock={false}
                                        />


                                    </div>



                                </div>

                            </div>
                            <div className="layer2">
                                <div className="end-date">
                                    <label className="date-label">End Date</label>



                                    <div className="date-box">

                                        <DatePicker
                                            // className="trend-date"
                                            onChange={(date) => setTrendEndDate(date)}
                                            value={trendEndDate}
                                            clearIcon={false}
                                        />

                                    </div>







                                </div>



                                <div className="end-time">
                                    <label className="time-label">End Time</label>



                                    <div className="time-box">
                                        <TimePicker
                                            // className="trend-time"
                                            onChange={(date) => setTrendEndTime(date)}
                                            value={trendEndTime}
                                            clearIcon={false}
                                            disableClock={false}
                                        />


                                    </div>



                                </div>



                            </div>
                            <div className="layer3">

                                <div className="interval-input">
                                    <div className="interval-label">Interval</div>

                                    <div className="dropdown-container" ref={intervalRef_custom}>

                                        <div
                                            className="dropdown-trigger"
                                            onClick={() => toggleDropdown("interval_custom")}
                                        >
                                            {intervalOptionList.find((option) => option.name === interval_custom)?.label}
                                            {/* <span className="dropdown-arrow">▼</span> */}
                                            <img className="dropdown-arrow" src={arrow} alt="▼" />

                                        </div>

                                        {isOpen === "interval_custom" && (
                                            <div className="dropdown-menu">
                                                {intervalOptionList.map((option) => (
                                                    <div
                                                        key={option.name}
                                                        className={`dropdown-item ${interval_custom === option.name ? "selected" : ""
                                                            }`}
                                                        // onClick={() =>


                                                        //     handleSelect("interval_custom", option.label)}
                                                        onClick={() => {
                                                            //console.log("Clicked on:", option.label);
                                                            handleSelect("interval_custom", option.name);
                                                        }}

                                                    >
                                                        {option.label}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="new-feature"></div>

                            </div>

                        </div>
                        <div className="bottom">

                            <button className="cancel-trends" onClick={hideCustomPopup_cancel}>Cancel</button>

                            <button className="generate-trends" onClick={() => { hideCustomPopup_onclick(); onGenerateReport(); }}>Generate Trends</button>




                        </div>
                    </div>
                </div>
            )}




        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    let pData = state.patientDataReducer.patientData && state.patientDataReducer.patientData[ownProps.bedId];
    let patientSessionId = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
        && state.patientDataReducer.patientData[ownProps.bedId].session_id;

    return {
        patientData: pData,
        patientSessionId: patientSessionId,
        config: state.configReducer.config
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewTrendContainer);